import {Component, OnInit, Inject, AfterViewInit, ViewChildren} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {UserService} from 'src/app/core/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../../../../../../core/class/message';
import FileUtils, {ContentType} from '../../../../../../core/services/file-utils';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {Observable, Observer, Subscription} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from '../../../../../../core/services/common.service';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {EnumSignMethod} from "../../../../../../core/constants/contract";

@Component({
  selector: 'app-view-digital-certificate',
  templateUrl: './view-digital-certificate.component.html',
  styleUrls: ['./view-digital-certificate.component.scss'],
})
export class ViewDigitalCertificateComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'stt',
    'userNameManager',
    'action'
  ];
  userName = new FormControl();
  options: string[];
  filteredOptions: Observable<string[]>;


  constructor(
    private digitalCertificateService: DigitalCertificateService,
    public dialogRef: MatDialogRef<ViewDigitalCertificateComponent>,
    private usService: UserService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    public message: Message,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public commonService: CommonService,
  ) {
    dialogRef.disableClose = true;
    this.id = data.id;
    this.idDetail = data.idDetail;
  }

  id = null;
  idDetail = null;
  certificate = {
    id: null,
    idDetail: null,
    enterpriseId: null,
    enterpriseName: '',
    serialNumber: '',
    taxCode: '',
    activeDate: '',
    expireDate: '',
    isDeleted: false,
    phoneNumber: '',
    typeCertificate: 0,
    typeCertificateInText: '',
    filePath: '',
    issuedTo: '',
    issuedBy: '',
    imagePath: '',
    lstIdNameDTO: [],
    cloudCaUsername: '',
    pin: '',
    isSync: null,
  };

  showPinCode: boolean = false;
  private isDisable: boolean;
  private fileUpload: File;
  private imageUrl: string | ArrayBuffer;
  private stampDivWrapper: HTMLElement;
  private stampSign: HTMLElement;
  private file: File;
  private success: boolean;
  public isFormChanging = false;

  @ViewChildren('focus') focus;
  fileName: any;
  infoMessage: any;
  progress: any;
  isUploading: any;
  public avatarUrl?: string;
  public loading = false;
  previewVisible = false;
  wrongFileFormat = false;
  fileTooLarge = false;
  enumSignMethod = EnumSignMethod;
  expireDate: any;
  isReload: any ;
  /**
   * Init component
   */
  ngOnInit() {
    this.getCertificateById(this.id, this.idDetail);
    this.userName.valueChanges.subscribe(value => {
      this.digitalCertificateService.getUserNameAndFullName(value).subscribe((rs: any) => {
        if (rs && Array.isArray(rs)) {
          // @ts-ignore
          this.filteredOptions = rs.map(value1 => value1.name);
        } else if (rs && rs.data && Array.isArray(rs.data)) {
          this.filteredOptions = rs.data.map(value1 => value1.name);
        }
      });
    });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 500);
  }

  // private _filter(value: string): string[] {
  //   // const filterValue = value.toLowerCase();
  //   // // console.log(this.options.filter(option => option.toLowerCase().includes(filterValue)));
  //   // return this.options ? this.options.filter(option => option.toLowerCase().includes(filterValue)) : null;
  //
  //   if (value) {
  //     this.digitalCertificateService.getUserNameAndFullName(value).subscribe((rs: any) => {
  //       if (rs) {
  //         this.options = rs.map(value1 => value1.name);
  //       }
  //       console.log(this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())));
  //       setTimeout(() => {
  //         return this.options ? this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())) : null;
  //       }, 1500);
  //       // console.log(this.options)
  //       // return this.options.filter(option => option['name'].toLowerCase().includes(value.toLowerCase()))[0];
  //     });
  //   }
  // }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    this.isFormChanging = true;
    this.wrongFileFormat = false;
    this.fileTooLarge = false;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          // this.fileUpload = info.file;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.wrongFileFormat = true;
        this.fileTooLarge = false;
        // this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.wrongFileFormat = false;
        this.fileTooLarge = true;
        // this.toastr.error(this.message.getMessage('messages.image_must_than_5m'));
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  }

  /**
   * Get certificate by Id certificate
   */
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  handlePreview = async (file: NzUploadFile) => {
    this.previewVisible = true;
  }

  // lấy ảnh
  getCertificateById(id: string, idDetail: string) {
    this.digitalCertificateService.viewDigitalCertificateDetail(id, idDetail).subscribe(rs => {
      this.certificate = rs.data;
      if(this.certificate.typeCertificate == 10){
        this.certificate.isSync = rs.data.isSync ? this.message.getMessage('button.yes_sign_method_default') : this.message.getMessage('button.no')
      }
      this.getSession();
      const {imagePath} = this.certificate;
      if (imagePath) {
        const imageDataBlob = this.commonService.b64toBlob(imagePath);
        const blobUrl = URL.createObjectURL(imageDataBlob);
        this.avatarUrl = blobUrl;
        // this.previewVisible = true;
      }
      // translate type certificate
      switch (this.certificate.typeCertificate) {
        case 0: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_server')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 1: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_usb')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 2: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_sim_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 3: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_otp')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 4: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_hsm')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.CLOUD_CA: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_cloud_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.EASY_CA: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_easy_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.VNEID: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_vneid')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
      }
    });
  }

  /**
   * Close dialog view certificate
   */
  onClose() {
    this.dialogRef.close(this.isReload);
  }

  onUpdateCertificateImage() {
    let data = {
      ...this.certificate,
      image: this.fileUpload,
      digitalCertificateId: this.certificate.id,
      digitalCertificateDetailId: this.idDetail
    };
    if (this.avatarUrl == '' || this.avatarUrl == null) {
      delete data.image
      delete data.imagePath
    }
    if(this.certificate.typeCertificate == 11){
      this.digitalCertificateService.updatePin({pin: this.certificate.pin, idDetail: this.idDetail, digitalCertificateId: this.id}).subscribe(rs =>{
        this.success = true;
        this.dialogRef.close();
      })
    }

    this.digitalCertificateService.updateImageCertificateBase64(data).then(rs => {
      this.toastr.success(this.message.getMessage('messages.update_success'));
      this.success = true;
      this.dialogRef.close(this.isReload);
    });
  }

  onSelectFile(Event) {
    if (typeof (FileReader) !== 'undefined') {
      let file: File;
      file = Event.target.files[0];
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;
        }
      } else {
        if (file.size <= 10485760) {
          this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            this.isDisable = true;
          }
        }
      }
    }
  }

  private checkContentTypeThenAddFile(file: File) {
    FileUtils.getContentType(file)
      .then((contentType) => {
        if (ContentType.PNG === contentType || ContentType.BMP === contentType || ContentType.JPEG === contentType) {
          this.fileUpload = file;
          this.imageUrl = URL.createObjectURL(file);
          const reader = new FileReader();
          const image = document.getElementById('#imagePreview');
          if (image) {
            image.setAttribute('src', URL.createObjectURL(file));
          }
          // tslint:disable-next-line:max-line-length
          const imageStamp = `<img src="${URL.createObjectURL(file)}" style="height: ${this.stampDivWrapper.style.height.replace('px', '')}px;"/>`;
          this.stampDivWrapper.innerHTML = imageStamp;
          this.stampSign.setAttribute('src', URL.createObjectURL(file));
        } else {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;

        }
      }).catch((err) => {
      this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
      this.isDisable = true;

    });
  }

  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
      };
    }
  }

  onUpload() {
    this.infoMessage = null;
    this.progress = 0;
    this.isUploading = true;
  }

  onCancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close(this.isReload);
        } else {
          dialogRe.close();
        }
      });
    } else {
      this.dialogRef.close(this.isReload);
    }
  }

  confirmDelete() {
        this.avatarUrl = '';
        this.fileUpload = null;
        this.certificate.imagePath = '';
        this.isFormChanging = true;
  }
  getSession(){
    if(this.certificate.typeCertificate !== 10){
      return
    }
    this.digitalCertificateService.endSessionCloudCa({
      digitalCertificateId: this.certificate.id,
      digitalCertificateDetailId: this.idDetail
    }).subscribe(res => {
      console.log(res);
      if(res.success){
        this.expireDate = res.data ? res.data.expireDate.replace(/-/g, '/') : null;
      }else {
        this.toastr.error(res.message)
      }
      
    })
  }

  deleteSession(){
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('digital_certificate_management.title_confirm_delete_session') + this.certificate.issuedTo
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.digitalCertificateService.deleteSessionCloudCa({
          digitalCertificateId: this.certificate.id,
          digitalCertificateDetailId: this.idDetail
        }).subscribe(res =>{
          if(res.success){
            this.isReload = {isReload: true}
            this.toastr.success(this.message.getMessage('digital_certificate_management.delete_session_success'))
            this.getSession()
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        dialogRe.close();
      }
    });
  }
}
